import type EnType from '../en-US/search';

export default {
  'search.SearchBar.label': 'Buscar',
  'search.SearchModal.errorScreen.helpText': 'Es posible que quieras verificar tu conexión de red.',
  'search.SearchModal.errorScreen.titleText': 'No se pueden obtener resultados',
  'search.SearchModal.footer.closeKeyAriaLabel': 'Tecla Escape',
  'search.SearchModal.footer.closeText': 'para cerrar',
  'search.SearchModal.footer.navigateDownKeyAriaLabel': 'Flecha abajo',
  'search.SearchModal.footer.navigateText': 'para navegar',
  'search.SearchModal.footer.navigateUpKeyAriaLabel': 'Flecha arriba',
  'search.SearchModal.footer.searchByText': 'Buscar por',
  'search.SearchModal.footer.selectKeyAriaLabel': 'Tecla Enter',
  'search.SearchModal.footer.selectText': 'para seleccionar',
  'search.SearchModal.noResultsScreen.noResultsText': 'No hay resultados para',
  'search.SearchModal.noResultsScreen.reportMissingResultsLinkText': 'Háznoslo saber.',
  'search.SearchModal.noResultsScreen.reportMissingResultsText':
    '¿Crees que esta consulta debería devolver resultados?',
  'search.SearchModal.noResultsScreen.suggestedQueryText': 'Intenta buscar',
  'search.SearchModal.placeholder': 'Buscar documentación',
  'search.SearchModal.searchBox.cancelButtonText': 'Cancelar',
  'search.SearchModal.searchBox.resetButtonTitle': 'Limpiar la consulta',
  'search.SearchModal.startScreen.favoriteSearchesTitle': 'Favoritos',
  'search.SearchModal.startScreen.noRecentSearchesText': 'No hay búsquedas recientes',
  'search.SearchModal.startScreen.recentSearchesTitle': 'Recientes',
  'search.SearchModal.startScreen.removeFavoriteSearchButtonTitle':
    'Eliminar esta búsqueda de favoritos',
  'search.SearchModal.startScreen.removeRecentSearchButtonTitle': 'Eliminar esta búsqueda del historial',
  'search.SearchModal.startScreen.saveRecentSearchButtonTitle': 'Guardar esta búsqueda',
} satisfies typeof EnType;
